module.exports = __webpack_public_path__ + "img/weChart.68a31520.png";